import Model from "../Model";
import ValidatableObject from "../validation/ValidatableObject";
import { IDomesticPaymentInstruction } from "./DomesticPaymentInstruction";
import { IAbroadPaymentInstruction } from "./AbroadPaymentInstruction";

export interface TPaymentInstruction {
  domestic?: IDomesticPaymentInstruction;
  abroad?: IAbroadPaymentInstruction;
}

export interface IPaymentInstruction extends TPaymentInstruction {}

const PaymentInstruction = Model(
  (model: TPaymentInstruction): IPaymentInstruction => {
    const _paymentInstruction: TPaymentInstruction = { ...model };

    const create = (
      paymentInstruction: IPaymentInstruction
    ): IPaymentInstruction => ValidatableObject(paymentInstruction);

    const paymentInstruction = {
      get domestic() {
        return _paymentInstruction.domestic;
      },
      set domestic(value) {
        _paymentInstruction.domestic = value;
      },
      get abroad() {
        return _paymentInstruction.abroad;
      },
      set abroad(value) {
        _paymentInstruction.abroad = value;
      }
    };

    return create(paymentInstruction);
  }
);

export default PaymentInstruction;
